export const BaseRoutes = {
  login: "/",
  fogotPassword: "/forgot-password",

  home: "/home",
  customerDetails: "/home/customer-details/:id",

  sellers: "/sellers",
  sellerDetails: "/sellers/:id",
  sellersLeads: "/sellers/leads",
  sellersLeadEdit: "/sellers/lead/:id/edit",
  sellersLeadCreate: "/sellers/lead/create",

  permissions: "/permissions",
  newUser: "/permissions/new-user",
  newRole: "/permissions/new-role",
  userDetails: "/permissions/user-details/:id",
  roleDetails: "/permissions/role-details/:id",

  account: "/account",

  accountDeletions: "/account-deletions",

  ticketIngestions: "/ticket-ingestions",
  ticketIngestionDetails: "/ticket-ingestions/:id",
  ticketIngestionBatchPayload: "/ticket-ingestions/batches/:id/payload",

  internalStore: "/internal-store",

  eventsPrivate: "/events-private",
  eventCreatePrivate: "/events-private/create",
  eventDetailsPrivate: "/events-private/:id",

  events: "/events",
  eventCreate: "/events/create",
  eventDetails: "/events/:id",
  exhibitorCreate: "/events/:eventId/exhibitor/create",
  exhibitorEdit: "/events/:eventId/exhibitor/:exhibitorId/edit",
  faqCreate: "/events/:eventId/faq/create",
  faqEdit: "/events/:eventId/faq/:faqId/edit",
  sessionCreate: "/events/:eventId/session/create",
  sessionEdit: "/events/:eventId/session/:sessionId/edit",
  trackCreate: "/events/:eventId/track/create",
  trackEdit: "/events/:eventId/track/:trackId/edit",
  locationCreate: "/events/:eventId/location/create",
  locationEdit: "/events/:eventId/location/:locationId/edit",
  registrationCreate: "/events/:eventId/registration/create",
  registrationEdit: "/events/:eventId/registration/:registrationId/edit",
};
